import{Outlet,Navigate}from"react-router-dom"
import{useAuthStore}from"@/stores/authStore"
export default function AuthLayout(){
  const{user,initialized}=useAuthStore()
  if(initialized&&user)return<Navigate to="/dashboard"replace/>
  return<div className="min-h-screen bg-dark-900 flex items-center justify-center p-6"><div className="w-full max-w-md"><Outlet/></div></div>
}